<template>
  <div class="access">
    <sui-form-field>
      <label>{{targetTitle}}</label>
      <sui-dropdown class="disabled" selection search>
        <i class="icon" :class="entity.icon" v-if="!targetLogo" />
        <Logo :entity="entity" :email="entity.email" inline v-if="targetLogo" />
        {{entity.name}}
      </sui-dropdown>
    </sui-form-field>
    <EntityActions v-model="entity.actions" fieldName="actions" v-if="entity.actions" />
    <EntityRules v-model="entity.rules" fieldName="rules" v-if="entity.rules" />
  </div>
</template>

<script>
  import capitalize from 'lodash/capitalize'
  import EntityRules from '@/components/forms/EntityRules'
  import EntityActions from '@/components/forms/EntityActions'

  export default {
    name: 'FormAccess',
    components: {
      EntityRules,
      EntityActions,
    },
    props: {
      entity: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {

      }
    },
    computed: {
      targetTitle() {
        return capitalize(this.entity.target)
      },
      targetLogo() {
        return this.entity._logo
      },
      fields() {
        return this.entity ? this.entity.getFields('updatingAccess', this.schema) : {}
      },
    },
  }
</script>
